import * as yup from 'yup';
import { EExtendedFieldTypes, EFormFieldsNames } from '../../../types/requestForm';
import { VILLAGE_REQUEST_TYPE_ANSWERS } from '../../../constants/requestForm/villageRequestTypeAnswers';
export var VILLAGE_REQUEST_TYPE_FIELD = {
  field: {
    label: '',
    name: EFormFieldsNames.VillageRequestType,
    type: EExtendedFieldTypes.RadioButtonGroupField,
    answers: VILLAGE_REQUEST_TYPE_ANSWERS,
    required: true,
    spliced: false
  },
  validation: yup.string().required('Выберите тип обращения')
};